export * from './anqServices.service';
import { AnqServicesService } from './anqServices.service';
export * from './apiCredentials.service';
import { ApiCredentialsService } from './apiCredentials.service';
export * from './batchSmsJob.service';
import { BatchSmsJobService } from './batchSmsJob.service';
export * from './billingTransactionLogs.service';
import { BillingTransactionLogsService } from './billingTransactionLogs.service';
export * from './dashBoard.service';
import { DashBoardService } from './dashBoard.service';
export * from './feedback.service';
import { FeedbackService } from './feedback.service';
export * from './localDelete.service';
import { LocalDeleteService } from './localDelete.service';
export * from './mTMOFilter.service';
import { MTMOFilterService } from './mTMOFilter.service';
export * from './message.service';
import { MessageService } from './message.service';
export * from './messageDeliveryStatus.service';
import { MessageDeliveryStatusService } from './messageDeliveryStatus.service';
export * from './platform.service';
import { PlatformService } from './platform.service';
export * from './platformServiceSubscriptionProcess.service';
import { PlatformServiceSubscriptionProcessService } from './platformServiceSubscriptionProcess.service';
export * from './senderIdMap.service';
import { SenderIdMapService } from './senderIdMap.service';
export * from './senderIdRequest.service';
import { SenderIdRequestService } from './senderIdRequest.service';
export * from './service.service';
import { ServiceService } from './service.service';
export * from './serviceBillingTransaction.service';
import { ServiceBillingTransactionService } from './serviceBillingTransaction.service';
export * from './serviceSubscription.service';
import { ServiceSubscriptionService } from './serviceSubscription.service';
export * from './smppAction.service';
import { SmppActionService } from './smppAction.service';
export * from './smppClient.service';
import { SmppClientService } from './smppClient.service';
export * from './smppCredentials.service';
import { SmppCredentialsService } from './smppCredentials.service';
export * from './smppTools.service';
import { SmppToolsService } from './smppTools.service';
export * from './smsBillingSettings.service';
import { SmsBillingSettingsService } from './smsBillingSettings.service';
export * from './smsClient.service';
import { SmsClientService } from './smsClient.service';
export * from './smsMerchant.service';
import { SmsMerchantService } from './smsMerchant.service';
export * from './smsPriceSetup.service';
import { SmsPriceSetupService } from './smsPriceSetup.service';
export * from './smsProcess.service';
import { SmsProcessService } from './smsProcess.service';
export * from './smsRouteMap.service';
import { SmsRouteMapService } from './smsRouteMap.service';
export * from './smsRoutes.service';
import { SmsRoutesService } from './smsRoutes.service';
export * from './smtpSettings.service';
import { SmtpSettingsService } from './smtpSettings.service';
export * from './subscriptions.service';
import { SubscriptionsService } from './subscriptions.service';
export * from './threshold.service';
import { ThresholdService } from './threshold.service';
export * from './transactionLog.service';
import { TransactionLogService } from './transactionLog.service';
export * from './userFeedback.service';
import { UserFeedbackService } from './userFeedback.service';
export * from './values.service';
import { ValuesService } from './values.service';
export * from './vat.service';
import { VatService } from './vat.service';
export * from './wallet.service';
import { WalletService } from './wallet.service';
export const APIS = [AnqServicesService, ApiCredentialsService, BatchSmsJobService, BillingTransactionLogsService, DashBoardService, FeedbackService, LocalDeleteService, MTMOFilterService, MessageService, MessageDeliveryStatusService, PlatformService, PlatformServiceSubscriptionProcessService, SenderIdMapService, SenderIdRequestService, ServiceService, ServiceBillingTransactionService, ServiceSubscriptionService, SmppActionService, SmppClientService, SmppCredentialsService, SmppToolsService, SmsBillingSettingsService, SmsClientService, SmsMerchantService, SmsPriceSetupService, SmsProcessService, SmsRouteMapService, SmsRoutesService, SmtpSettingsService, SubscriptionsService, ThresholdService, TransactionLogService, UserFeedbackService, ValuesService, VatService, WalletService];
